import React from 'react';
import ExerciseCard from '../shared/ExerciseCard';
import TranslatableText from '../shared/TranslatableText';

const FillInPanel = ({
  questions,
  currentQuestionIndex,
  wordOptions,
  userAnswers,
  onAnswerDrop,
  onBack,
  onNext,
  onSubmit,
  topic,
}) => {
  const currentQuestion = questions[currentQuestionIndex - 1];
  const userAnswer = userAnswers[currentQuestion.id];

  const handleWordClick = (word) => {
    onAnswerDrop(currentQuestion.id, word);
  };

  const allAnswered = questions.every(q => userAnswers[q.id]);
  const isLastQuestion = currentQuestionIndex === questions.length;

  // Split the partial answer by "__" to create the blank
  const parts = currentQuestion.partial_answer.split('__');

  return (
    <ExerciseCard>
      {/* Header with progress */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-800">
          Otazka {currentQuestionIndex} z {questions.length}
        </h2>
        <div className="text-sm font-semibold text-gray-500">
          {Object.keys(userAnswers).length} / {questions.length} zodpovezeno
        </div>
      </div>

      {/* Question text */}
      <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-4 mb-4">
        <div className="text-gray-500 mb-2 font-semibold text-sm">
          Otazka:
        </div>
        <div className="text-lg text-gray-800 font-semibold">
          <TranslatableText text={currentQuestion.question} textColor="#1f2937" topic={topic} />
        </div>
      </div>

      {/* Partial answer with blank */}
      <div className="bg-gray-50 p-4 rounded-xl mb-4">
        <div className="text-gray-500 mb-3 font-semibold text-sm">
          Doplňte odpověd:
        </div>
        <div className="flex items-center gap-2 flex-wrap p-3 bg-white rounded-lg border-2 border-gray-200">
          <TranslatableText text={parts[0]} topic={topic} />

          {/* Answer display */}
          <span
            className={`inline-block px-4 py-2 rounded-lg text-center min-w-[200px] font-semibold ${
              userAnswer
                ? 'bg-green-100 text-green-700 border-2 border-green-400'
                : 'bg-gray-100 text-gray-400 border-2 border-dashed border-blue-400'
            }`}
          >
            {userAnswer || '________'}
          </span>

          {parts[1] && <TranslatableText text={parts[1]} topic={topic} />}
        </div>
      </div>

      {/* Word options - clickable */}
      <div className="bg-gray-50 p-4 rounded-xl mb-4">
        <div className="text-gray-500 mb-3 font-semibold text-sm">
          Vyberte správné slovo a doplňte ho do věty:
        </div>
        <div className="flex gap-3 justify-center flex-wrap">
          {wordOptions.map((word, index) => (
            <button
              key={index}
              onClick={() => handleWordClick(word)}
              className="px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-lg text-lg font-semibold shadow-md hover:shadow-lg transition-all hover:-translate-y-0.5"
            >
              {word}
            </button>
          ))}
        </div>
      </div>

      {/* Navigation buttons */}
      <div className="flex justify-between gap-3">
        <button
          onClick={onBack}
          disabled={currentQuestionIndex === 1}
          className={`py-3 px-6 rounded-lg font-semibold transition-all ${
            currentQuestionIndex === 1
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-gray-500 hover:bg-gray-600 text-white'
          }`}
        >
          Zpět
        </button>

        <div className="flex gap-3">
          {!isLastQuestion && (
            <button
              onClick={onNext}
              className="py-3 px-6 bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-semibold transition-all"
            >
              Další
            </button>
          )}

          {isLastQuestion && (
            <button
              onClick={onSubmit}
              disabled={!allAnswered}
              className={`py-3 px-6 rounded-lg font-semibold transition-all ${
                allAnswered
                  ? 'bg-green-500 hover:bg-green-600 text-white'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed opacity-60'
              }`}
            >
              Odevzdat
            </button>
          )}
        </div>
      </div>

      {isLastQuestion && !allAnswered && (
        <div className="mt-3 text-center text-red-500 font-semibold text-sm">
          Odpovězte prosím na všechny otázky před odevzdáním
        </div>
      )}
    </ExerciseCard>
  );
};

export default FillInPanel;
